import angular from 'angular';

angular.module('cxHttpServices').factory('reminderHttpSvc', ['$http', 'appUrls', reminderHttpSvc]);

function reminderHttpSvc($http, appUrls) {
  var baseUrl = appUrls.api + '/api/Reminder/';

  function handleSuccess(response) {
    return response.data;
  }

  return {
    getReminders: function() {
      return $http.get(baseUrl + 'Get').then(handleSuccess);
    },
    createReminder: function(reminder) {
      return $http.post(baseUrl + 'Post', reminder).then(handleSuccess);
    },
    updateReminder: function(reminder) {
      return $http.put(baseUrl + 'Put', reminder).then(handleSuccess);
    },
    removeReminder: function(reminderId) {
      return $http.delete(baseUrl + 'Delete/' + reminderId).then(handleSuccess);
    },
  };
}
